import axios from "../lib/axios"
import { CREATE_ADVERTISE, DELETE_ADVERTISE, FIND_MANY_ADVERTISE } from "../lib/endpoints/advertise";

interface InputCreateNotification {
    title?: string
    message?: string
    description?: string
    startDate: string
}

export const getAllNotificationService = async () => {
    try {
        const res = await axios.post(FIND_MANY_ADVERTISE);
        return res?.data
    } catch (error) {
        throw error
    }
}

export const deleteNotificationService = async (id: string) => {
    try {
        await axios.delete(DELETE_ADVERTISE + id);
    } catch (error) {
        throw error
    }
}

export const createNotificationService = async (input: InputCreateNotification) => {
    try {
        const inputData = {
            title: input.title,
            message: input.message,
            description: input.description,
            startDate: input.startDate
        }
        const res = await axios.post(CREATE_ADVERTISE, inputData)
        return res?.data
    } catch (error) {
        throw error
    }
}